import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'

const JIO_PRIMARY = '#24397A'

export const shadow = {
  shadowColor: '#00000029' as ColorOptions,
  shadowOffset: {
    width: -3,
    height: 1,
  },
  shadowOpacity: 1,
  shadowRadius: 7,
  elevation: 3,
}

export const styles = {
  container: (isMobile: boolean) =>
    ({
      borderRadius: 20,
      borderWidth: 1,
      borderColor: 'GREY_1_SEPARATOR',
      alignSelf: 'center',
      minWidth: isMobile ? 320 : 390,
      maxWidth: isMobile ? '100%' : undefined,
      // mt: '10%',
      ...shadow,
    } as BoxProps),
  upiViewContainer: {
    bg: JIO_PRIMARY as ColorOptions,
    pt: 20,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    height: 520,
  } as BoxProps,
  textContainer: {
    pv: 12,
    pb: 4,
    direction: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  peopeName: {
    fontSize: 12,
    color: 'BLACK_21' as ColorOptions,
    textAlign: 'left',
    fontWeight: 'BOLD',
    fontFamily: 'jiotype-bold',
  } as TextNewProps,
  upiName: {
    fontSize: 12,
    color: 'MEDIUM_GREY' as ColorOptions,
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  dataContainer: {
    ph: 12,
    bg: 'WHITE',
    pb: 16,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
  } as BoxProps,
  dottedView: {
    borderStyle: 'dashed',
    borderTopWidth: 1,
    alignSelf: 'stretch',
    borderColor: 'GREY_MATTE',
  } as BoxProps,
  UPiImageContainer: {
    pt: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  upiTextName: (left: string) =>
    ({
      fontSize: 6,
      color: 'TINY_GREY' as ColorOptions,
      fontFamily: 'jiotype-medium',
      fontWeight: '800',
      textAlign: left,
    } as TextNewProps),
  merchantContainer: {
    flexDirection: 'row',
  } as BoxProps,
  merchIndividualImage: {
    pl: 4,
  } as BoxProps,
  imageContainer: {} as BoxProps,
  whiteQrCodeView: {
    bg: 'WHITE',
    minWidth: 270,
    alignSelf: 'center',
    borderRadius: 26,
    minHeight: 280,
    pv: 16,
  } as BoxProps,
  myJioText: {
    fontSize: 10,
    color: 'BLACK_75' as ColorOptions,
    fontFamily: 'jiotype-medium',
    fontWeight: '600',
  } as TextNewProps,
  myJioView: {
    flexDirection: 'row',
    ph: 25,
    pb: 7,
    pt: 8,
    alignSelf: 'center',
    borderStyle: 'dashed',
    borderWidth: 1,
    borderColor: 'DISABLED_GREY',
    borderRadius: 80,
  } as BoxProps,
  scanText: {
    fontSize: 7,
    color: 'PENCIL_GREY' as ColorOptions,
    fontFamily: 'jiotype-medium',
    fontWeight: '600',
    lineHeight: 10,
    letterSpacing: 0.9,
  } as TextNewProps,
  scanBg: {
    bg: 'WHITE',
    position: 'absolute',
    alignSelf: 'center',
    left: '15%',
    top: -5,
  } as BoxProps,
  qrCodeContainer: {
    ph: 12,
    alignSelf: 'center',
  } as BoxProps,
  qrImgContainer: {
    alignSelf: 'center',
    flex: 1,
    justifyContent: 'center',
  } as BoxProps,
}
